import styles from "./ToolsAround.module.css"
function ToolsAround({element,onClick,style}){
    style = style?style:{}
    return (
        <div onClick={onClick} style={style} className={styles.toolAround}>
            {element}

        </div>
    )
}
export default ToolsAround